class VwHbsOrderIlacDTO {
    id?: number = null;
    orderDetayId?: number = null;
    islemTanimId?: number = null;
    periyodId?: number = null;
    periyodSure?: number = null;
    doz1?: number = null;
    doz2?: number = null;
    dozBirimId?: number = null;
    kullanimSekilId?: number = null;
    aciklama?: string = "";
    acil?: string = "";
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    iptal?: string = "";
    iptalTarihi?: string = null;
    iptalKullanici?: number = null;
    adi?: string = "";
    depoTanimId?: number = null;
    depoDonemId?: number = null;
    secimTuru?: number = null;
    istenenmiktar?: number = null;
    islemdurum?: number = null;
    depoVerilen?: number = null;
    plantarih?: string = null;
    plansaat?: string = "";
    onaydrTarih?: string = null;
    onaydrId?: number = null;
    onaydrAciklama?: string = "";
    depoTarih?: string = null;
    depokullaniciId?: number = null;
    depoAciklama?: string = "";
    depoIslemTanimId?: number = null;
    mevcut?: number = null;
    muracaatId?: number = null;
    servisId?: number = null;
    ekleyenkullaniciBilgi?: string = null;
    onaylayanDoktor?: string = null;
    rednedenId?: number = null;
    rednedenAciklama?: string = "";
    depoIslemTanimAd?: string = "";
    reddedenKullaniciId?: number = null;
    disTemin?: string = "H";
    hastaAdSoyad?: string = "";
}
export default VwHbsOrderIlacDTO;